import React from 'react';
import ReactDOM from 'react-dom/client';  // Cambia la importación
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const root = ReactDOM.createRoot(document.getElementById('root')); 

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
